import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ItemList from "../components/ItemList.jsx";

function createMarkup(htmlstring) { return { __html: htmlstring }; }

export default class SearchCard extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    const { index, loading } = this.props;

    if (0 == index && !loading) {
      this.itemWrapper.focus();
    }
  }

  getPaperNumber(url) {
    return url.substr('/papers/x'.length);
  }

  getDisplayTypeName(displaytypename, type, url) {
    if (type == 'working_paper') {
      if (url.search('/papers/h') >= 0) {
        displaytypename = 'Historical '.concat(displaytypename);
      }
      else if (url.search('/papers/t') >= 0) {
        displaytypename = 'Technical '.concat(displaytypename);
      }
    }
    return displaytypename;
  }

  render() {
    const {
      abstract,
      authors,
      description,
      displaytypename,
      editors,
      investigators,
      jobtitle,
      programs,
      publisheddate,
      displaydate,
      title,
      type,
      imageurl,
      url,
      metalinks,
      source,
      certifiedrandom
    } = this.props;

    const listOptions = {
      "last_item_symbol": certifiedrandom ? "ⓡ" : "&",
      "item_concatenator": ","
    };

    return (
      <div className="digest-card">
        {imageurl && (
          <img className="digest-card__image" src={imageurl} alt="" />
        )}
        {title && (
          <div className="digest-card__title digest-card__title--search">
            <a ref={el => (this.itemWrapper = el)} href={source && source.url ? source.url : url}>
              {title}
              {jobtitle && <span>, {jobtitle}</span>}
            </a>
          </div>
        )}
        {(displaydate || displaytypename) && (
          <div className="digest-card__date">
            {displaydate && (
              <span className="digest-card__label">
                {displaydate}
              </span>
            )}
            {displaydate && displaytypename && <span> - </span>}
            { displaytypename && <span className="digest-card__label">
              { this.getDisplayTypeName(displaytypename, type, url) }
            </span> }
            { type == 'working_paper' && url && <a href={ url } className="paper-card__paper_number">
              { this.getPaperNumber(url) }
            </a> }
          </div>
        )}

        { programs && programs.length > 0 && <ItemList items={programs} label="Programs(s)" /> }
        { authors && authors.length > 0 && <ItemList items={authors} options={listOptions}  label="Author(s)" /> }
        { investigators && investigators.length > 0 && <ItemList items={investigators} options={listOptions}  label="Investigators(s)" /> }
        { editors && editors.length > 0 && <ItemList items={editors} options={listOptions}  label="Editors(s)" /> }
        { abstract && <div className="digest-card__summary">{abstract}</div> }
        { description && (
          <div className="digest-card__summary">{description}</div>
        )}
        { metalinks && <div dangerouslySetInnerHTML={createMarkup(metalinks)} /> }
      </div>
    );
  }
}

const { array, bool, func, number, string } = PropTypes;

SearchCard.propTypes = {
  abstract: string,
  authors: array,
  description: string,
  displaytypename: string,
  editors: array,
  index: number,
  investigators: array,
  jobtitle: string,
  loading: bool,
  programs: array,
  publisheddate: string,
  displaydate: string,
  title: string,
  type: string,
  url: string,
  certifiedrandom: bool
};

SearchCard.defaultProps = {
  certifiedrandom: false
}
